import { ApolloClient, InMemoryCache } from "@apollo/client";

export enum GraphQLErrors {
    NotAuthenticated = "AUTH_NOT_AUTHENTICATED",
}

export const graphQLClient = new ApolloClient({
    cache: new InMemoryCache({ resultCaching: false, addTypename: false }),
    defaultOptions: {
        watchQuery: { fetchPolicy: "no-cache" },
        query: { fetchPolicy: "no-cache" },
    },
});
